module.exports = __webpack_public_path__ + "img/servidores-icon.12cd41d2.png";